import { type GridOption } from 'echarts/types/dist/shared';

export type BoundingRect = {
  x: number;
  y: number;
  width: number;
  height: number;
};

// FIXME: when dom height/(width) less than sum of top and bottom/(left and right)
// ECharts will auto adapt this scenes, The result returned by the function below will be inaccurate(wrong)
// see this Example:https://echarts.apache.org/examples/zh/editor.html?c=bar-background&code=PYBwLglsB2AEC8sDeAoWsDmAnCATAXMmurGKPgOQAcADAKQUA0x6ARsGGQLaW0PPoAvgNgAPAIKiIAZ0KoSpAJ4gApoQoBjAIZgVGYFkVMWsXDq2EA2hQCyMJrAoAVAK4qHFAOorcHpwAsXDwAxHA8AZR0Il2gKAF1iYWJFSRk5EzBlNUcANy0AGzcKRJFpFRwVWVhLE3kFU3MrAEYAJhpGWDb22CaAVm7aDoB2bqam0YBmGjiRBUzVdVYtLGN62Gl_YAB3ACEtDQBrbGAYglIsN1mSJcPj0_DM_Oy6tY1gfIN1LAwlgAomwY9QEA7o0AB0LQAlMU1oITHD0AlBABuIA
export function getCoordBoundingRect(dom: HTMLDivElement, gridOption?: GridOption): BoundingRect {
  const defaultGridOption = {
    top: 60,
    left: '10%',
    right: '10%',
    bottom: 70
  };
  const PERCENT_BASE = 100;
  const gridOptionResult = Object.assign(defaultGridOption, gridOption || {});
  const domWidth = dom.clientWidth;
  const domHeight = dom.clientHeight;
  const topPadding =
    typeof gridOptionResult.top === 'number'
      ? gridOptionResult.top
      : (domHeight * parseFloat(gridOptionResult.top)) / PERCENT_BASE;
  const bottomPadding =
    typeof gridOptionResult.bottom === 'number'
      ? gridOptionResult.bottom
      : (domHeight * parseFloat(gridOptionResult.bottom)) / PERCENT_BASE;
  const leftPadding =
    typeof gridOptionResult.left === 'number'
      ? gridOptionResult.left
      : (domWidth * parseFloat(gridOptionResult.left)) / PERCENT_BASE;
  const rightPadding =
    typeof gridOptionResult.right === 'number'
      ? gridOptionResult.right
      : (domWidth * parseFloat(gridOptionResult.right)) / PERCENT_BASE;

  return {
    x: leftPadding,
    y: topPadding,
    width: domWidth - leftPadding - rightPadding,
    height: domHeight - topPadding - bottomPadding
  };
}

export function niceRange(
  min: number,
  max: number,
  config?: {
    absoluteInterval?: number;
    relativeInterval?: number;
    // logBase?: number;
  }
): [number, number] {
  // 兜底处理，防止外部min与max处理错误
  const minTemp = Math.min(min, max);
  const maxTemp = Math.max(min, max);
  const BASE_NUMBER = 10;
  const FIX_PERCENT = 0.1;
  const MIN_EQUAL_MAX = minTemp === maxTemp;
  const defaultRelativeInterval = 1;

  // 连续轴
  const formatterMin = MIN_EQUAL_MAX ? minTemp * (1 - FIX_PERCENT) : minTemp;
  const formatterMax = MIN_EQUAL_MAX ? maxTemp * (1 + FIX_PERCENT) : maxTemp;
  const range = formatterMax - formatterMin;
  const powerSize = Math.floor(Math.log10(range)) - 1;

  let result = [];
  const relativeInterval = (config && config.relativeInterval) || defaultRelativeInterval;
  const relativeRoundSize = BASE_NUMBER ** powerSize * relativeInterval;
  const relativeMinFixed = Math.floor(formatterMin / relativeRoundSize) * relativeRoundSize;
  const relativeMaxFixed = Math.ceil(formatterMax / relativeRoundSize) * relativeRoundSize;
  result = [relativeMinFixed, relativeMaxFixed];

  if (config && config.absoluteInterval) {
    const absoluteRoundSize = config.absoluteInterval;
    const absoluteMinFixed = Math.floor(formatterMin / absoluteRoundSize) * absoluteRoundSize;
    const absoluteMaxFixed = Math.ceil(formatterMax / absoluteRoundSize) * absoluteRoundSize;
    result = [
      Math.min(relativeMinFixed, absoluteMinFixed),
      Math.max(relativeMaxFixed, absoluteMaxFixed)
    ];
  }

  return result as [number, number];
}
